import isClient from '@mobi/utils/browser/isClient'

const trackDocumentRegistration = () => {
  if (isClient()) {
    if (window.fbq) {
      window.fbq('trackCustom', 'document_registration', {})
    }
  }
}

const trackPurchase = ({ value, groupIds }) => {
  if (isClient()) {
    if (window.fbq) {
      window.fbq('trackCustom', 'Purchase-Front-End', {
        value: value,
        currency: 'BRL',
        contents: groupIds,
        content_type: 'product_group',
      })
    }
  }
}

export default {
  trackDocumentRegistration,
  trackPurchase,
}
